// extracted by mini-css-extract-plugin
export default {"hover-icon":"resource-configuration-label-card_hover-icon__bovxF","button":"resource-configuration-label-card_button__A6We-","card":"resource-configuration-label-card_card__HBaEq"};